export default __webpack_public_path__ + "static/media/up-ar.cedf884f.svg";